export const APP_NAME = "Concrete Sales Assistant";
export const AWS_REGION = "eu-central-1";
export const MODEL_ID_FOR_CHART = "anthropic.claude-3-sonnet-20240229-v1:0";
export const AGENT_RUNTIME_ARN = "arn:aws:bedrock-agentcore:eu-central-1:491600935070:runtime/customersupportassistant-cKekNHDmOl";
export const AGENT_ENDPOINT_NAME = "DEFAULT";
export const WELCOME_MESSAGE = "Tere! Olen betooni müügiesindaja. Kuidas saan teid aidata?";
export const MAX_LENGTH_INPUT_SEARCH = 2000;
export const LAST_K_TURNS = 10;

// LiveKit configuration
export const LIVEKIT_TOKEN_ENDPOINT = process.env.REACT_APP_LIVEKIT_TOKEN_ENDPOINT || 'https://60n4vhxvl9.execute-api.eu-central-1.amazonaws.com/livekit-token';

export const PLANNER_APP_NAME = "Planner Agent";
export const PLANNER_WELCOME_MESSAGE = "Hello! I'm your AI strategy consultant. Let's explore how AI agents can transform your business.";
